import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, Select2Data } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm();

  const [SubCategory, setSubCategory] = useState();
  const GetEditData = async () => {
    const response = await getData(`/masters/cab-fare/${id}`);
    reset(response?.data);
    setValue("sub_category_id", response?.data?.sub_category_id);
  };
  useEffect(() => {
    GetEditData();
  }, []);
  const Subcategory = watch("sub_category_id");

  const onSubmit = async (data) => {
    try {
      const response = await postData(`/masters/cab-fare/${id}`, data);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [cabType, setCabType] = useState([]);

  const GetAllCabType = async () => {
    const response = await getData("/all-cab-type");

    if (response?.success) {
      setCabType(await Select2Data(response?.data?.data, "cab_type_id"));
    }
  };

  const GetAllSubCategory = async () => {
    const response = await getData("/all-subcategory");

    if (response?.success) {
      setSubCategory(await Select2Data(response?.data, "sub_category_id"));
    }
  };

  useEffect(() => {
    GetAllCabType();
    GetAllSubCategory();
  }, []);
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Cab Fare
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Cab Type</Form.Label>
                    <Controller
                      name="cab_type_id" // name of the field
                      {...register("cab_type_id", {
                        required: "Select Cab type",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.cab_type_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={cabType}
                          // onChange={(selectedOption) => {
                          //   field.onChange(selectedOption.value);
                          // }}
                        />
                      )}
                    />
                    {errors.cab_type_id && (
                      <span className="text-danger">
                        {errors.cab_type_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Trip Type</Form.Label>
                    <Controller
                      name="sub_category_id" // name of the field
                      {...register("sub_category_id", {
                        required: "Select Trip",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.sub_category_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          // onChange={(selectedOption) => {
                          //   field.onChange(selectedOption.value);
                          //   setSubCategory(selectedOption.value);
                          // }}
                          options={SubCategory}
                          // options={[
                          //   { value: 1, label: "One Way", name: "One Way" },
                          //   {
                          //     value: 2,
                          //     label: "Round Trip",
                          //     name: "Round Trip",
                          //   },
                          //   {
                          //     value: 3,
                          //     label: "Local Packages",
                          //     name: "Local Packages",
                          //   },
                          //   {
                          //     value: 4,
                          //     label: "Airport Transport",
                          //     name: "Airport Transport",
                          //   },
                          // ]} // Static options
                        />
                      )}
                    />
                    {errors.sub_category_id && (
                      <span className="text-danger">
                        {errors.sub_category_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              {(Subcategory?.value === 1 ||
                Subcategory?.value === 3 ||
                Subcategory?.value === 4) && (
                <>
                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Form.Group>
                        <div className="">
                          <Form.Label>Fare</Form.Label>
                        </div>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            min={1}
                            name="one_way_fare_below"
                            placeholder="One way Fare"
                            className={classNames("", {
                              "is-invalid": errors?.fare,
                            })}
                            {...register("fare", {
                              required: " Fare  is required",
                              validate: (value) =>
                                value > 0 || "Fare must be greater than 0",
                            })}
                            onKeyDown={(e) => {
                              if (
                                e.key === "+" ||
                                e.key === "e" ||
                                e.key === "E" ||
                                (isNaN(Number(e.key)) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Tab" &&
                                  e.key !== ".") || // Allow decimal point
                                (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasteData = e.clipboardData.getData("text");
                              if (!/^\d*\.?\d*$/.test(pasteData)) {
                                // Allow only numbers with optional single decimal
                                e.preventDefault();
                              }
                            }}
                          />
                        </InputGroup>
                        {errors.fare && (
                          <span className="text-danger">
                            {errors.fare.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                </>
              )}
              {Subcategory?.value === 2 && (
                <>
                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Form.Group>
                        <div className="">
                          <Form.Label>Fare (per kilometer)</Form.Label>
                        </div>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            min={1}
                            name="local_packages_fare"
                            placeholder="Local packages Fare"
                            className={classNames("", {
                              "is-invalid": errors?.fare,
                            })}
                            {...register("fare", {
                              required: "Local packages Fare is required",
                              validate: (value) =>
                                value > 0 || "Fare must be greater than 0",
                            })}
                            onKeyDown={(e) => {
                              if (
                                e.key === "+" ||
                                e.key === "e" ||
                                e.key === "E" ||
                                (isNaN(Number(e.key)) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Tab" &&
                                  e.key !== ".") || // Allow decimal point
                                (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasteData = e.clipboardData.getData("text");
                              if (!/^\d*\.?\d*$/.test(pasteData)) {
                                // Allow only numbers with optional single decimal
                                e.preventDefault();
                              }
                            }}
                          />
                        </InputGroup>
                        {errors.fare && (
                          <span className="text-danger">
                            {errors.fare.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Form.Group>
                        <div className="">
                          <Form.Label>Fare (per hour)</Form.Label>
                        </div>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            min={1}
                            name="local_packages_hour"
                            placeholder="local packages hour"
                            className={classNames("", {
                              "is-invalid": errors?.hour,
                              validate: (value) =>
                                value > 0 || "Fare must be greater than 0",
                            })}
                            {...register("hour", {
                              required: "fare hour is required",
                            })}
                            onKeyDown={(e) => {
                              if (
                                e.key === "+" ||
                                e.key === "e" ||
                                e.key === "E" ||
                                (isNaN(Number(e.key)) &&
                                  e.key !== "Backspace" &&
                                  e.key !== "Tab" &&
                                  e.key !== ".") || // Allow decimal point
                                (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasteData = e.clipboardData.getData("text");
                              if (!/^\d*\.?\d*$/.test(pasteData)) {
                                // Allow only numbers with optional single decimal
                                e.preventDefault();
                              }
                            }}
                          />
                        </InputGroup>
                        {errors.hour && (
                          <span className="text-danger">
                            {errors.hour.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                </>
              )}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center mb-2">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Fare(Extra kilometer)</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          min={1}
                          name="extra_fare"
                          placeholder="Extra Fare"
                          className={classNames("", {
                            "is-invalid": errors?.extra_fare,
                          })}
                          {...register("extra_fare", {
                            required: "fare is required",
                            validate: (value) =>
                              value > 0 || "Fare must be greater than 0",
                          })}
                          onKeyDown={(e) => {
                            if (
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E" ||
                              (isNaN(Number(e.key)) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== ".") || // Allow decimal point
                              (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*\.?\d*$/.test(pasteData)) {
                              // Allow only numbers with optional single decimal
                              e.preventDefault();
                            }
                          }}
                        />
                      </InputGroup>
                      {errors.extra_fare && (
                        <span className="text-danger">
                          {errors.extra_fare.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
